import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "13",
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.5 2.5C0.5 1.25736 1.50736 0.25 2.75 0.25H5.87868C6.47542 0.25 7.04771 0.487053 7.46967 0.90901L8.09099 1.53033C8.23164 1.67098 8.42241 1.75 8.62132 1.75H13.25C14.4926 1.75 15.5 2.75736 15.5 4V5.15135C15.0587 4.89609 14.5464 4.75 14 4.75H2C1.45357 4.75 0.94126 4.89609 0.5 5.15135V2.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.5 7.75V10.75C0.5 11.9926 1.50736 13 2.75 13H13.25C14.4926 13 15.5 11.9926 15.5 10.75V7.75C15.5 6.92157 14.8284 6.25 14 6.25H2C1.17157 6.25 0.5 6.92157 0.5 7.75Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }